// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__94jJu {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #80808012;
  border-top: 1px solid #8080801a;
  padding: 0rem 2rem;
  position: relative; }

.styles_narrativeSection__DIIXe {
  width: 100%; }

.styles_contentWrapper__mGZiW {
  max-width: 90rem;
  margin: 0 auto;
  text-align: center; }

.styles_headerSection__g\\+ZsW {
  margin-bottom: 2rem; }
  .styles_headerSection__g\\+ZsW h3 {
    margin-top: 2rem;
    font-size: 2.5rem; }

.styles_sectionTitle__fpyZU {
  font-size: 2.5rem;
  font-weight: 300;
  color: #808080e6;
  margin-bottom: 2rem;
  line-height: 1.2;
  text-align: left; }
  @media (min-width: 48rem) {
    .styles_sectionTitle__fpyZU {
      font-size: 3.75rem; } }
  @media (min-width: 64rem) {
    .styles_sectionTitle__fpyZU {
      font-size: 4.5rem; } }

.styles_decorativeDivider__sf3Dz {
  width: 6rem;
  height: 0.125rem;
  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);
  border-radius: 0.0625rem; }

.styles_narrativeContent__eEMRB {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem; }

.styles_narrativeParagraph__ptbZH {
  font-size: 2.25rem;
  font-weight: 300;
  color: #808080b8;
  line-height: 1.8;
  text-align: left; }

.styles_highlightedWord__OGbOB {
  font-weight: 400;
  font-style: italic;
  margin: 0 0.25rem;
  position: relative;
  display: inline; }

.styles_soulHighlight__Srrbi {
  color: #6366f1;
  font-size: 1.5rem; }
  @media (min-width: 48rem) {
    .styles_soulHighlight__Srrbi {
      font-size: 1.875rem; } }
  @media (min-width: 64rem) {
    .styles_soulHighlight__Srrbi {
      font-size: 2.25rem; } }

.styles_qualityHighlight__E3ldu {
  color: #dc2626;
  font-size: 1.25rem; }
  @media (min-width: 48rem) {
    .styles_qualityHighlight__E3ldu {
      font-size: 1.5rem; } }
  @media (min-width: 64rem) {
    .styles_qualityHighlight__E3ldu {
      font-size: 1.875rem; } }

.styles_depthHighlight__RMk3w {
  color: #8b5cf6;
  font-size: 1.25rem; }
  @media (min-width: 48rem) {
    .styles_depthHighlight__RMk3w {
      font-size: 1.5rem; } }
  @media (min-width: 64rem) {
    .styles_depthHighlight__RMk3w {
      font-size: 1.875rem; } }

.styles_sheltersHighlight__MWj8T {
  color: #6366f1;
  font-size: 1.875rem;
  font-style: normal; }
  @media (min-width: 48rem) {
    .styles_sheltersHighlight__MWj8T {
      font-size: 2.25rem; } }
  @media (min-width: 64rem) {
    .styles_sheltersHighlight__MWj8T {
      font-size: 2.75rem; } }

.styles_meaningHighlight__tsqk7 {
  color: #8b5cf6;
  font-size: 1.875rem;
  font-style: normal; }
  @media (min-width: 48rem) {
    .styles_meaningHighlight__tsqk7 {
      font-size: 2.25rem; } }
  @media (min-width: 64rem) {
    .styles_meaningHighlight__tsqk7 {
      font-size: 2.75rem; } }

.styles_boldHighlight__OW-a8 {
  font-weight: 600;
  font-size: 2rem;
  color: #000000; }

.styles_strikeHighlight__Kv8Mr {
  text-decoration: line-through;
  text-decoration-thickness: 0.15rem;
  text-decoration-color: rgba(0, 0, 0, 0.65); }

.styles_scrollNext__4jQjj {
  position: absolute;
  bottom: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/NarrativeSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBCGe;EDFf,+BCGgB;EDFhB,kBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;EADrB;IAGI,gBAAgB;IAChB,iBAAiB,EAAA;;AAKrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBClBgB;EDmBhB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB,EAAA;EAEhB;IARF;MASI,kBAAkB,EAAA,EAMrB;EAHC;IAZF;MAaI,iBAAiB,EAAA,EAEpB;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,6DAA6D;EAE7D,wBAAwB,EAAA;;AAG1B;EAEE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAA;;AAGX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBCpDgB;EDqDhB,gBAAgB;EAChB,gBAAgB,EAAA;;AAalB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,iBAAiB,EAAA;EAEjB;IAJF;MAKI,mBAAmB,EAAA,EAMtB;EAHC;IARF;MASI,kBAAkB,EAAA,EAErB;;AAED;EACE,cAAc;EACd,kBAAkB,EAAA;EAElB;IAJF;MAKI,iBAAiB,EAAA,EAMpB;EAHC;IARF;MASI,mBAAmB,EAAA,EAEtB;;AAED;EACE,cAAc;EACd,kBAAkB,EAAA;EAElB;IAJF;MAKI,iBAAiB,EAAA,EAMpB;EAHC;IARF;MASI,mBAAmB,EAAA,EAEtB;;AAED;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAA;EAElB;IALF;MAMI,kBAAkB,EAAA,EAMrB;EAHC;IATF;MAUI,kBAAkB,EAAA,EAErB;;AAED;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAA;EAElB;IALF;MAMI,kBAAkB,EAAA,EAMrB;EAHC;IATF;MAUI,kBAAkB,EAAA,EAErB;;AAID;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAA;;AAGhB;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,0CAA0C,EAAA;;AAG5C;EACE,kBAAkB;EAClB,YAAY,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: $grey7;\n  border-top: 1px solid $grey10;\n  padding:0rem 2rem;\n  position: relative;\n}\n\n.narrativeSection {\n  width: 100%;\n}\n\n.contentWrapper {\n  max-width: 90rem;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.headerSection {\n  margin-bottom: 2rem;\n  & h3 {\n    margin-top: 2rem;\n    font-size: 2.5rem;\n  }\n}\n\n\n.sectionTitle {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: $grey90;\n  margin-bottom: 2rem;\n  line-height: 1.2;\n  text-align: left;\n  \n  @media (min-width: 48rem) {\n    font-size: 3.75rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 4.5rem;\n  }\n}\n\n.decorativeDivider {\n  width: 6rem;\n  height: 0.125rem;\n  background: linear-gradient(90deg, #6366f1, #dc2626, #8b5cf6);\n  // margin: 0 auto;\n  border-radius: 0.0625rem;\n}\n\n.narrativeContent {\n  // max-width: 64rem;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.narrativeParagraph {\n  font-size: 2.25rem;\n  font-weight: 300;\n  color: $grey72;\n  line-height: 1.8;\n  text-align: left;\n  \n  @media (min-width: 48rem) {\n    // font-size: 1.5rem;\n    // text-align: center;\n  }\n  \n  @media (min-width: 64rem) {\n    // font-size: 1.875rem;\n    // line-height: 1.7;\n  }\n}\n\n.highlightedWord {\n  font-weight: 400;\n  font-style: italic;\n  margin: 0 0.25rem;\n  position: relative;\n  display: inline;\n}\n\n.soulHighlight {\n  color: #6366f1;\n  font-size: 1.5rem;\n  \n  @media (min-width: 48rem) {\n    font-size: 1.875rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 2.25rem;\n  }\n}\n\n.qualityHighlight {\n  color: #dc2626;\n  font-size: 1.25rem;\n  \n  @media (min-width: 48rem) {\n    font-size: 1.5rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 1.875rem;\n  }\n}\n\n.depthHighlight {\n  color: #8b5cf6;\n  font-size: 1.25rem;\n  \n  @media (min-width: 48rem) {\n    font-size: 1.5rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 1.875rem;\n  }\n}\n\n.sheltersHighlight {\n  color: #6366f1;\n  font-size: 1.875rem;\n  font-style: normal;\n  \n  @media (min-width: 48rem) {\n    font-size: 2.25rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 2.75rem;\n  }\n}\n\n.meaningHighlight {\n  color: #8b5cf6;\n  font-size: 1.875rem;\n  font-style: normal;\n  \n  @media (min-width: 48rem) {\n    font-size: 2.25rem;\n  }\n  \n  @media (min-width: 64rem) {\n    font-size: 2.75rem;\n  }\n}\n\n\n\n.boldHighlight {\n  font-weight: 600;\n  font-size: 2rem;\n  color: #000000;\n}\n\n.strikeHighlight {\n  text-decoration: line-through;\n  text-decoration-thickness: 0.15rem;\n  text-decoration-color: rgba(0, 0, 0, 0.65);\n}\n\n.scrollNext {\n  position: absolute;\n  bottom: 1rem;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__94jJu`,
	"narrativeSection": `styles_narrativeSection__DIIXe`,
	"contentWrapper": `styles_contentWrapper__mGZiW`,
	"headerSection": `styles_headerSection__g+ZsW`,
	"sectionTitle": `styles_sectionTitle__fpyZU`,
	"decorativeDivider": `styles_decorativeDivider__sf3Dz`,
	"narrativeContent": `styles_narrativeContent__eEMRB`,
	"narrativeParagraph": `styles_narrativeParagraph__ptbZH`,
	"highlightedWord": `styles_highlightedWord__OGbOB`,
	"soulHighlight": `styles_soulHighlight__Srrbi`,
	"qualityHighlight": `styles_qualityHighlight__E3ldu`,
	"depthHighlight": `styles_depthHighlight__RMk3w`,
	"sheltersHighlight": `styles_sheltersHighlight__MWj8T`,
	"meaningHighlight": `styles_meaningHighlight__tsqk7`,
	"boldHighlight": `styles_boldHighlight__OW-a8`,
	"strikeHighlight": `styles_strikeHighlight__Kv8Mr`,
	"scrollNext": `styles_scrollNext__4jQjj`
};
export default ___CSS_LOADER_EXPORT___;
